export default __webpack_public_path__ + "static/media/Unlimited Morph Dusk Fiend.6cf022dc.jpg";